import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Trouble with Vacation",
  "description": "",
  "published": "2017-03-01T00:00:00.000Z",
  "redirect_from": ["/blog/trouble-vacation/swizec/7463"],
  "categories": "Opinions, Personal, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://instagram.fsnc1-5.fna.fbcdn.net/t51.2885-15/e35/16788409_411935005808905_281051866597425152_n.jpg",
        "alt": null
      }}></img></p>
    <p>{`Vacation kills momentum.`}</p>
    <p>{`I've experienced this momentum killing effect twice this year. The first was after I came back from the `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/60-seconds-2000-miles/swizec/7334"
      }}>{`epic Grand Canyon roadtrip`}</a>{`. The second is right now, coming back from a company retreat in Cabo.`}</p>
    <p>{`Don't get me wrong, I love vacation. I `}<em parentName="p">{`need`}</em>{` vacation. Coming back from vacation and restarting the pre-vacation momentum is the death. Newton's first law: An object at rest stays at rest, and an object in motion stays in motion with the same speed and in the same direction unless acted upon by an unbalanced force.`}</p>
    <p>{`You can think of daily productive habits as momentum. If you go to work for 8 hours every day, doing so becomes reflexive. Momentum. If you go to the gym every day after work, you'll keep doing it unless you make an active decision not to. Momentum.`}</p>
    <p>{`If you write an article or make a video every day, you can keep doing it. Sometimes it’s easier, sometimes it’s harder, but it's easy to put `}<em parentName="p">{`something`}</em>{` out there. Even if you write every other day, you can keep doing it almost without thinking. Momentum.`}</p>
    <p>{`And then vacation stops all that.`}</p>
    <p>{`The unbalanced force of vacation throws you out of whack. Maybe you can keep up some daily exercise, but it's not quite the same as going to the gym. Maybe you can keep writing a little bit…`}</p>
    <p>{`But the pool and jacuzzi and cocktails and friends and nightclubs and lounge chairs and books are soooooooo inviting, and you realize just how tired you've been all these weeks. You deserve a little break, don't you? God damn it, you've earned it!`}</p>
    <p>{`So you don't. And then you're fucked.`}</p>
    <p>{`Do you reeeaaaaally want to get back to all of that work you've been doing before? Like `}<em parentName="p">{`really`}</em>{` really? You loved it, and you loved the results for sure, but you can't deny how much easier life would be if you, you know, `}<em parentName="p">{`didn't`}</em>{`. You just saw how easy it was. Relaxing and nice and nothing bad happened.`}</p>
    <p>{`Or did it?`}</p>
    <p>{`In my case, not writing has a direct effect on traffic. The classic content treadmill problem.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/traffic-chart.png",
        "alt": null
      }}></img></p>
    <p>{`At the end of December, I went on a roadtrip, and traffic went down. Then in January, it took a few weeks for the traffic to build back up. Then I fell off the wagon and started posting irregularly again, and traffic fell down to maintenance levels.`}</p>
    <p>{`The week off didn't have as much of an effect as it did in December, but we'll see what happens. Stitching together a newsletter for Friday is going to be hard. ?`}</p>
    <p>{`Fingers crossed this short rumination starts the momentum. Here's a video of some snorkeling fishes.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      